import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';
import { Tabs, Tab } from 'react-bootstrap';
// Tabs
import StaffDesignationRevisionsTab from './StaffDesignationRevisionsTab';
import StaffDesignationApprovesTab from './StaffDesignationApprovesTab';

class StaffDesignationsTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: 0,
      updated: 0,
      key: 1,
      staff_id: this.props.staff_id,
    };
    this.refreshData = this.refreshData.bind(this);
  }
  // Handlers
  handleNavTab(state, key) {
    var change = {};
    change[state] = key;
    this.setState(change);
    this.setState({overlay: {message: '', type: '', status: ''}});
  }
  // LM
  componentWillReceiveProps(newProps) {
    if(typeof newProps.staff_designations !== 'undefined' &&  typeof newProps.staff_designations_open !== 'undefined' && this.state.loaded === 0) {
      this.setState({
        staff_id: newProps.staff_id,
        staff_designations: newProps.staff_designations,
        staff_designations_open: newProps.staff_designations_open,
        staff_designations_open_info: newProps.staff_designations_open.info,
        staff_designations_finalized: newProps.staff_designations_finalized,
        lines: newProps.staff_designations.dlines,
        info: newProps.staff_designations.info,
        staff_aircraft_models: newProps.staff_designations.staff_aircraft_models,
        observations: newProps.staff_designations.info.staff_revision_observations,
        staff_tasks: newProps.staff_designations.staff_tasks,
        staff_licenses: newProps.staff_designations.staff_licenses,
        lines_open: newProps.staff_designations_open.dlines,
        staff_aircraft_models_open: newProps.staff_designations_open.staff_aircraft_models,
        observations_open: newProps.staff_designations_open.info.staff_revision_observations,
        staff_tasks_open: newProps.staff_designations_open.staff_tasks,
        staff_licenses_open: newProps.staff_designations_open.staff_licenses,
        designations_list: newProps.designations_list,
        staff_revisions: newProps.staff_revisions,
        staff_revisions_list: newProps.staff_revisions_list,
        loaded: 1
      });
    }
  }

  refreshData (event) {
    this.props.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/colaborador/designacoes/' + self.state.staff_id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({
            staff_designations: responseJson.data.staff_designations,
            staff_designations_open: responseJson.data.staff_designations_open,
            staff_designations_open_info: responseJson.data.staff_designations_open.info,
            staff_designations_finalized: responseJson.data.staff_designations_finalized,
            lines: responseJson.data.staff_designations.dlines,
            info: responseJson.data.staff_designations.info,
            staff_aircraft_models: responseJson.data.staff_designations.staff_aircraft_models,
            observations: responseJson.data.staff_designations.info.staff_revision_observations,
            staff_tasks: responseJson.data.staff_designations.staff_tasks,
            staff_licenses: responseJson.data.staff_designations.staff_licenses,
            lines_open: responseJson.data.staff_designations_open.dlines,
            staff_aircraft_models_open: responseJson.data.staff_designations_open.staff_aircraft_models,
            observations_open: responseJson.data.staff_designations_open.info.staff_revision_observations,
            staff_tasks_open: responseJson.data.staff_designations_open.staff_tasks,
            staff_licenses_open: responseJson.data.staff_designations_open.staff_licenses,
            staff_revisions: responseJson.data.staff_revisions,
            staff_revisions_list: responseJson.data.staff_revisions_list,
            updated: 1,
          });
        }
        if(typeof event.message !== 'undefined') {
          self.props.handleAlert(event.message, event.status, 'open');
        } else {
          self.props.handleAlert("", "", 'closed');
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <h3 className="page-title">Designações</h3>
  <hr/>
  <Tabs activeKey={this.state.key} onSelect={this.handleNavTab.bind(this, 'key')} id="controlled-tab-example">
    <Tab eventKey={1} title="Revisões de Designações">
      <StaffDesignationRevisionsTab handleAlert={this.props.handleAlert} staff_id={this.state.staff_id} staff_designations={this.state.staff_designations} staff_designations_open={this.state.staff_designations_open} designations_list={this.state.designations_list} staff_revisions={this.state.staff_revisions} staff_revisions_list={this.state.staff_revisions_list} refreshData={this.refreshData} updated={self.state.updated}/>
    </Tab>
    <Tab eventKey={2} title="Aprovações de Designações">
      <StaffDesignationApprovesTab handleAlert={this.props.handleAlert} staff_id={this.state.staff_id} staff_designations_finalized={this.state.staff_designations_finalized} refreshData={this.refreshData} updated={self.state.updated}/>
    </Tab>

  </Tabs>
</div>
    );
  }
}

export default StaffDesignationsTab;



// WEBPACK FOOTER //
// ./src/Components/Staffs/Elements/StaffDesignationsTab.js